import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NavController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { ToastService } from '../../_core/services/toast.service';
import { AuthService } from '../../auth/auth.service';
import { ActivatedRoute } from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms'; // 👈 ADD THIS
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    selector: 'app-verify',
    templateUrl: './verify.component.html',
    imports: [IonicModule, ReactiveFormsModule, CommonModule],
    styleUrls: ['./verify.component.scss'],
})
export class VerifyComponent implements OnInit {
    @Input() phone: string;
    @Input() countryCode = '+1';
    form: UntypedFormGroup;
    isLoading = false;

    constructor(
        private navCtrl: NavController,
        private fb: UntypedFormBuilder,
        private authService: AuthService,
        private toastService: ToastService,
        private activatedRoute: ActivatedRoute,
        private translateService: TranslateService) { }

    ngOnInit() {
        this.buildForm();
    }

    buildForm() {
        if (!this.countryCode) this.countryCode = '+1';
        this.form = this.fb.group({
            country_code: [this.countryCode, [Validators.required, Validators.pattern('([+]{1})([0-9]{1,3})')]],
            phone: [this.phone, [Validators.required, Validators.pattern('([1-9]{1})[0-9]{5,15}')]],
            code: [null, [Validators.required, Validators.minLength(4)]]
        });
    }

    verify() {
        if (this.form.valid) {
            this.isLoading = true;
            this.authService.verify(this.form.value)
                .pipe(finalize(() => this.isLoading = false))
                .subscribe(
                    (responseSuccess) => {
                        this.toastService.presentToast(responseSuccess.message);
                        const redirectUrl = this.activatedRoute.snapshot.queryParamMap.get('returnTo') || '/';

                        this.navCtrl.navigateRoot(redirectUrl);
                    },
                    (responseError) => {
                        //console.log(responseError);
                    }
                );
        } else {
            this.handleErrors();
        }

    }

    async handleErrors() {
        let errorMessage = '';
        if (this.form.get('country_code').invalid) {
            errorMessage = this.translateService.instant('Country code must start with + followed by 1 to 3 digits');
        } else if (this.form.get('phone').invalid) {
            errorMessage = this.translateService.instant('Phone must include area code and phone number. Digits only. If your first digit is 0 remove it.');
        } else {
            errorMessage = this.translateService.instant('Code must have 4 digits.');
        }
        this.toastService.presentDangerToast(errorMessage);
    }

}
